import React from 'react';
import BookingList from './BookingList';

/*
 * Live jobs — setiap booking yang sedang berjalan.
 *
 * Tipis di atas arketipe BookingList, seperti di paket client: layar ini,
 * Scheduled, Completed dan Cancelled adalah fungsi yang sama dengan daftar
 * status yang berbeda.
 *
 * Status "berjalan" ini sama dengan ACTIVE di getDispatchOverview, supaya badge
 * di sidebar dan jumlah baris di sini tidak pernah berbeda.
 */
const LiveJobs = () => (
  <BookingList
    current="live"
    breadcrumb={['Operations', 'Live jobs']}
    title="Live jobs"
    lead="Every booking currently in flight."
    slug="live-jobs"
    statuses="created,approved,arrived,reviewed,started,paused,resumed"
    legacyHref="/siteadmin/jobs"
    live
    showAge
    emptyTitle="Nothing in flight"
    emptyMsg="No booking is currently active. New ones appear here as soon as they are requested."
  />
);

export default LiveJobs;
